import React from "react";
import PolicyLayout from "./PolicyLayout";

const ClientTerms = () => {
  const sections = [
    {
      title: "1. Agreement to Terms",
      content: "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. By accessing or using our website, you agree to be bound by these Terms and Conditions and our Privacy Policy.</p>"
    },
    {
      title: "2. Intellectual Property Rights",
      content: "<p>Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site are owned or controlled by us.</p>"
    },
    {
      title: "3. User Representations",
      content: "<p>By using the Site, you represent and warrant that: (1) all registration information you submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information and promptly update such registration information as necessary.</p>"
    },
    {
      title: "4. Prohibited Activities",
      content: "<p>You may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.</p>"
    },
    {
      title: "5. Governing Law",
      content: "<p>These Terms shall be governed by and defined following the laws of the State of Virginia. The Just Generation Foundation and yourself irrevocably consent that the courts of Virginia shall have exclusive jurisdiction to resolve any dispute which may arise in connection with these terms.</p>"
    }
  ];

  return <PolicyLayout title="Terms & Conditions" lastUpdated="October 24, 2024" sections={sections} />;
};

export default ClientTerms;